import {
  useFormErrorNotification,
  useFormSuccessNotification,
} from "@babackapp/react-hook-forms-components/form-notifications";
import { useMutation } from "@tanstack/react-query";
import { $api } from "../generated/client";
import type { CreateViewDto } from "../generated/schema";
import useInvalidateShop from "./use-invalidate-shop";

export default function useAddShopView(shopId: string) {
  const successNotification = useFormSuccessNotification();
  const errorNotification = useFormErrorNotification();
  const invalidateShop = useInvalidateShop(shopId);

  const mutation = $api.useMutation("post", "/shops/{shopId}/views");

  return useMutation({
    onSuccess: () => {
      invalidateShop();
      successNotification();
    },
    onError: () => {
      errorNotification();
    },
    mutationFn: (body: CreateViewDto) => {
      return mutation.mutateAsync({ params: { path: { shopId } }, body });
    },
  });
}
